import { render } from "./f4pViewer.vue?vue&type=template&id=4c5c3868"
import script from "./f4pViewer.js?vue&type=script&lang=js"
export * from "./f4pViewer.js?vue&type=script&lang=js"

import "./f4pViewer.vue?vue&type=style&index=0&id=4c5c3868&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__